// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"021035e2","453":"7a9edf04","732":"3e63d520"}[chunkId] + ".chunk.js";
};